/* eslint-disable no-use-before-define */
import React from 'react'
import { Field, } from 'formik'
import { Fields, Flyout, SectionHeader, SectionBody, subscribe, publish, unsubscribe} from '../../twd/twd'
import { useOrders, TODAY } from '../use-orders'

export const Form = ({
    handleSubmit,
    resetForm,
    values,
    errors,
    validateForm,
}) => {

    const { showFilters, setShowFilters, setFilters } = useOrders()

    React.useEffect(() => {
        let subId = subscribe('orders_reset_filters.orders_form', ({isApply=false} = {}) => {
            resetForm({
                tradeSubmitDateRangeMin: TODAY(),
                tradeSubmitDateRangeMax: TODAY(),
                holdInvType: [],
                holdCusip:'',
                tradeType:[],
                tradeStatus:[],
            })
            setTimeout(() => {
                validateForm()
                if (isApply) {
                    setFilters(values)
                }
            }, 10)
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])

    return <React.Fragment>

    <div className="container">
    <div className="row">
    <div className={"col-md-12"}>
        <SectionHeader
            title="Show filters"
            cls="subhead"
            arrowSize='medium'
            show={showFilters}
            setShow={setShowFilters}
        />
    </div>
    </div>


    <SectionBody show={showFilters}>
    <form onSubmit={(e) => { handleSubmit(e) }}>
    <div className="row">
        <div className={"col-md-10"}>
            <div className="row">
            <div className="col-md-2">
                <Field
                    data-name="view-orders-date-min"
                    name="tradeSubmitDateRangeMin"
                    component={Fields.Maturity}
                    label={<Flyout
                        label="From date"
                        html={'Select your preferred date range using the following format: "mm/dd/yyyy" (e.g., January 1, 2028 should be entered as "01/01/2028"). The date range cannot exceed 3 years.'}
                        />}
                    error={errors.tradeSubmitDateRangeMin}
                />
            </div>
            <div className="col-md-2">
                <Field
                    data-name="view-orders-date-min"
                    name="tradeSubmitDateRangeMax"
                    component={Fields.Maturity}
                    label={<Flyout
                        label="To date"
                        html={'Select your preferred date range using the following format: "mm/dd/yyyy" (e.g., January 1, 2028 should be entered as "01/01/2028"). The date range cannot exceed 3 years.'}
                        />}
                    error={errors.tradeSubmitDateRangeMax}
                />
            </div>
            <div className="col-md-2">
                <Field
                    data-name="view-orders-product"
                    name="holdInvType"
                    component={Fields.Select}
                    options={[
                        {label:'All', value:[] },
                        {label:'Agency', value:'A' },
                        {label:'Brokered CD', value:'S' },
                        {label:'Corporate', value:'C' },
                        {label:'Municipal', value:'M' },
                        {label:'Treasury', value:'T' },
                        {label:'Other', value:['P','L','O','K','R'] }
                    ]}
                    label={"Product"}
                    error={errors.holdInvType}
                />
            </div>
            <div className="col-md-2">
                <Field
                    data-name="view-orders-cusip"
                    name="holdCusip"
                    component={Fields.Text}
                    label={<Flyout
                        label="CUSIP"
                        html={'To search for orders by CUSIP, enter a full or partial (5 character minimum) CUSIP number. For example, entering "36966" will return all orders with a CUSIP beginning with 36966. To conduct a multi-CUSIP search, enter full CUSIP numbers separated by commas.'}
                        />}
                    error={errors.holdCusip}
                />
            </div>
            <div className="col-md-2">
                <Field
                    data-name="view-orders-trade-type"
                    name="tradeType"
                    component={Fields.Select}
                    options={[
                        {label:'All', value:[] },
                        {label:'Buy', value:'B' },
                        {label:'Sell', value:'S' },
                        {label:'Offer Quote Request', value:'F' },
                        {label:'Bid Quote Request', value:'W' }
                    ]}
                    label={"Type"}
                    error={errors.tradeType}
                />
            </div>
            <div className="col-md-2">
                <Field
                    data-name="view-orders-trade-status"
                    name="tradeStatus"
                    component={Fields.Select}
                    options={[
                        {label:'All', value:[] },
                        {label:'Open Order', value:'OPEN_ORDER' },
                        {label:'Executed', value:'EXECUTED' },
                        {label:'Change', value:'CHANGE' },
                        {label:'Expired', value:'EXPIRED' },
                        {label:'Canceled', value:'CANCELLED' },
                        {label:'Pending Canceled', value:'PENDING_CANCELED' },
                        {label:'Rejected', value:'REJECTED' },
                    ]}
                    label={"Status"}
                    error={errors.tradeStatus}
                />
            </div>
            </div>
        </div>

        <div className={"col-md-2"}>
            <label className="xs-hide">&nbsp;</label>
            <button
                data-name="view-orders-apply-filters"
                type="button"
                className="btn btn-primary-outline btn-block"
                disabled={errors.length>0}
                onClick={() => {
                    setFilters({...values, ts:Date.now()})
                }}
            >Apply filters</button>
            <button
                data-name="view-orders-reset-filters"
                type="button"
                className="btn btn-link btn-block text-center"
                onClick={() => {
                    publish('orders_reset_filters')
                }}
            >Reset filters</button>
        </div>

    </div>
    </form>
    </SectionBody>

    </div>
    </React.Fragment>


}



// WEBPACK FOOTER //
// ./src/orders/filters/form.js